<template>
  <div class="login-container">
    <!-- Header with brand & #338DF5 accent -->
    <div class="login-header">
      <h1>
        <i class="fas fa-bolt"></i> 
        Aurora
      </h1>
      <p>Welcome back · Sign in to your account</p>
    </div>

    <div class="login-form-wrapper">
      <!-- Login Form with unified submit handler -->
      <form id="main_form" @submit.prevent="handle_login">
        <!-- Email field -->
        <div class="input-group">
          <i class="fas fa-envelope"></i>
          <input 
          id="password"
            ref="emailInput"
            type="email" 
            name="email"
            v-model="loginForm.email" 
            placeholder="Email address" 
            autocomplete="email"
          >
          <!-- Validation errors will appear here automatically -->
        </div>
        <!-- Password field -->
        <div class="input-group password-wrapper">
          <i class="fas fa-lock"></i>
          <input id="password"
            ref="passwordInput"
            type="password"
            name="password"
            v-model="loginForm.password" 
            placeholder="Password" 
            autocomplete="current-password"
          >
          <!-- Validation errors will appear here automatically -->
        </div>

        <!-- Remember me + Forgot password row -->
        <div class="form-extras">
          <a href="#" class="forgot-link" @click.prevent="showForgotHint">Forgot password?</a>
        </div>

        <!-- Login CTA button -->
        <button type="submit" class="form-submit-btn login-btn">
          <i class="fas fa-arrow-right-to-bracket"></i> Sign In
        </button>

        <!-- Signup button/link -->
        <div class="signup-prompt">
          <span>Don't have an account? </span>
          <button type="button" class="signup-btn" @click="triggerSignup">
            <i class="fas fa-user-plus"></i> Sign up now
          </button>
        </div>
      </form>
      <!-- Dynamic message area for global feedback (Wrong credentials, server down, etc.) -->
    </div>
  </div>
</template>

<script>
import { form_api_submit } from '../utils/FormSubmit'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      error_msg: '',
    };
  },
  methods: {
    async handle_login() {
      // Reset error message
      this.error_msg = '';

      // Frontend validation
      

      // Prepare URL
      const fullUrl = (this.$apiUrl || 'http://localhost:8000/api/') + 'auth/login';

      // Call the reusable function
      const result = await form_api_submit({
        url: fullUrl,
        method: 'POST',
        data: this.loginForm,
        curr_form_id: '#main_form',
        take_form_data: false
      });

      // Handle response
      if (result.success) {
        // Success - Login successful
        localStorage.setItem('user_token', result.data.token);
        // alert("You are logged IN!");
        // this.$router.push('/dashboard');
      } else {
        // Show error message (for non-validation errors)
        // this.$toast(result.message || 'Login failed', false);
      }
    },
    showForgotHint() {
      alert("Password reset function placeholder.");
    },
    triggerSignup() {
      alert("Signup navigation placeholder.");
    }
  }
};
</script>

<style scoped>
/* Add styles for validation errors */

/* Your existing styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-container {
  width: 100%;
  max-width: 460px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(2px);
  border-radius: 2.25rem;
  box-shadow: 0 25px 45px -12px rgba(51,141,245,0.25), 0 0 0 1px rgba(51,141,245,0.1);
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.3s ease;
  margin: 3.5rem auto;
}

.login-container:hover {
  transform: translateY(-3px);
  box-shadow: 0 30px 50px -15px rgba(51,141,245,0.35);
}

.login-header {
  background: linear-gradient(115deg, #338DF5 0%, #1C6FD1 100%);
  padding: 1.8rem 1.8rem 1.5rem;
  text-align: center;
  color: white;
}

.login-header h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.3px;
  margin-bottom: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: white;
}

.login-header h1 i {
  font-size: 1.9rem;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
}

.login-header p {
  font-size: 0.9rem;
  opacity: 0.92;
  font-weight: 400;
}

.login-form-wrapper {
  padding: 1.8rem 1.8rem 1.5rem;
}

.input-group {
  margin-bottom: 1.4rem;
  position: relative;
}

.input-group i:first-child {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 1.2rem;
  transition: color 0.2s;
  pointer-events: none;
  z-index: 1;
}

.input-group input {
  width: 100%;
  padding: 0.9rem 1rem 0.9rem 2.8rem;
  font-size: 0.95rem;
  font-family: 'Inter', sans-serif;
  border: 1.5px solid #E2E8F0;
  border-radius: 10px;
  background: #FFFFFF;
  transition: all 0.25s;
  outline: none;
  font-weight: 500;
  color: #1E293B;
}

.password-wrapper {
  position: relative;
}

.password-wrapper input {
  padding-right: 3rem;
}

.input-group input:focus {
  border-color: #338DF5;
  box-shadow: 0 0 0 3px rgba(51,141,245,0.15);
}

.form-extras {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0.3rem 0 1.8rem;
  font-size: 0.85rem;
}

.forgot-link {
  color: #338DF5;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s;
  font-size: 0.85rem;
}

.forgot-link:hover {
  color: #1C6FD1;
  text-decoration: underline;
}

.login-btn {
  width: 100%;
  background: linear-gradient(95deg, #338DF5, #2273CF);
  border: none;
  padding: 0.9rem;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  border-radius: 3rem;
  color: white;
  cursor: pointer;
  transition: all 0.25s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  letter-spacing: 0.2px;
  margin-top: 0.2rem;
  box-shadow: 0 4px 12px rgba(51,141,245,0.3);
}

.login-btn:hover {
  transform: scale(1.01);
  background: linear-gradient(95deg, #2779E0, #1A63BE);
  box-shadow: 0 10px 18px -6px rgba(51,141,245,0.5);
}

.login-btn:active {
  transform: scale(0.98);
}

.signup-prompt {
  text-align: center;
  margin-top: 1.6rem;
  font-size: 0.9rem;
  color: #475569;
}

.signup-btn {
  background: none;
  border: none;
  color: #338DF5;
  font-weight: 700;
  cursor: pointer;
  font-size: 0.95rem;
  font-family: 'Inter', sans-serif;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 4px;
}

.signup-btn:hover {
  color: #1C6FD1;
  transform: translateX(3px);
  text-decoration: underline;
}

.message-area {
  font-size: 0.85rem;
  margin-top: 1.2rem;
  padding: 0.75rem 1rem;
  border-radius: 2rem;
  background: #F1F5F9;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1E293B;
  animation: fadeSlide 0.25s ease;
}

.message-area.error {
  background: #FEF2F2;
  color: #DC2626;
  border-left: 4px solid #DC2626;
}

@keyframes fadeSlide {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 560px) {
  .login-container {
    margin: 0.75rem auto;
  }
  .login-header {
    padding: 1.2rem 1.5rem 1rem;
  }
  .login-form-wrapper {
    padding: 1.2rem 1.5rem 1rem;
  }
}

@media (max-height: 700px) {
  .login-header {
    padding: 1.2rem 1.5rem 1rem;
  }
  .login-form-wrapper {
    padding: 1.2rem 1.5rem 1rem;
  }
  .input-group {
    margin-bottom: 1rem;
  }
  .form-extras {
    margin-bottom: 1.2rem;
  }
  .signup-prompt {
    margin-top: 1rem;
  }
}

button:focus-visible, input:focus-visible {
  outline: 2px solid #338DF5;
  outline-offset: 2px;
}
</style>